import { render, staticRenderFns } from "./MovedButNotDeletedDossiers.vue?vue&type=template&id=2503de16&scoped=true&"
import script from "./MovedButNotDeletedDossiers.vue?vue&type=script&lang=ts&"
export * from "./MovedButNotDeletedDossiers.vue?vue&type=script&lang=ts&"
import style0 from "./MovedButNotDeletedDossiers.vue?vue&type=style&index=0&id=2503de16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503de16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2503de16')) {
      api.createRecord('2503de16', component.options)
    } else {
      api.reload('2503de16', component.options)
    }
    module.hot.accept("./MovedButNotDeletedDossiers.vue?vue&type=template&id=2503de16&scoped=true&", function () {
      api.rerender('2503de16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MovedButNotDeletedDossiers.vue"
export default component.exports